/**
 * Adds formatting of promotions into proper array of objects.
 * @param {array} data - The array of promotions to be formatted.
 * @return {array} The formatted array in reverse in order to render them in descending order.
 */
export default function getPromotions (data) {
  let newData = []

  for (let i = 0; i < data.length; i++) {
    newData.push({
      promotion_id: data[i].promotion_id,
      details: {
        promotion_name: data[i].promotion_name,
        company_name: data[i].company_name,
        device_name: data[i].device_name,
        active: data[i].active
      }
    })
  }

  return newData.reverse()
}
